// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen and (max-width: 575px){.nav-heading{display:none}}@media only screen and (min-width: 576px){.nav-heading{display:inline-block;align-self:center}}`, "",{"version":3,"sources":["webpack://./src/components/AppHeader/views/NavHeading.scss"],"names":[],"mappings":"AAEE,0CAFF,aAGM,YAAA,CAAA,CAGJ,0CANF,aAOM,oBAAA,CACA,iBAAA,CAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
